const Home = () => import('@/components/Home.vue');
const HomeLgd = () => import('@/components/HomeLgd.vue');

/*
const User = () => import('@/components/User.vue');
const Place = () => import('@/components/Place.vue');
const Trip = () => import('@/components/Trip.vue');
const Requests = () => import('@/components/Requests.vue');
*/
const ManagePlace = () => import('@/components/ManagePlace.vue');
const ManageTrip = () => import('@/components/ManageTrip.vue');
const ManageOuting = () => import('@/components/ManageOuting.vue');
const ManageCmnt = () => import('@/components/ManageCmnt.vue');
const ManageGeo = () => import('@/components/ManageGeo.vue');
/*
const ManageUser = () => import('@/components/ManageUser.vue');
const ItemList = () => import('@/components/ItemList.vue');
const AuthorsList = () => import('@/components/AuthorsList.vue');
const UsersList = () => import('@/components/UsersList.vue');
const TripPlacesList = () => import('@/components/TripPlacesList.vue');
const UserPlacesList = () => import('@/components/UserPlacesList.vue');
const UserTripsList = () => import('@/components/UserTripsList.vue');
const UserItemsList = () => import('@/components/UserItemsList.vue');
const UserCmntsList = () => import('@/components/UserCmntsList.vue');
const Doc = () => import('@/components/Doc.vue');
const Map = () => import('@/components/Map.vue');
const Login = () => import('@/components/Login.vue');
const CreateUser = () => import('@/components/CreateUser.vue');
const Search = () => import('@/components/Search.vue');
const GeoRefs = () => import('@/components/GeoRefs.vue');
const ManageRef = () => import('@/components/ManageRef.vue');
const Foo= () => import('@/components/Foo.vue');
const Test = () => import('@/components/Test.vue');
const NotFound = () => import('@/components/NotFound.vue');
*/

//import HomeLgd from '@/components/HomeLgd.vue'
import User from '@/components/User.vue'
import Place from '@/components/Place.vue'
import Tour from '@/components/Tour.vue'
import Outing from '@/components/Outing.vue'
import Offer from '@/components/Offer.vue'
import Company from '@/components/Company.vue'
import Requests from '@/components/Requests.vue'
/*
import ManagePlace from '@/components/ManagePlace.vue'
import ManageTrip from '@/components/ManageTrip.vue'
import ManageOuting from '@/components/ManageOuting.vue'
import ManageCmnt from '@/components/ManageCmnt.vue'
*/
import ManageUser from '@/components/ManageUser.vue'
import ManageCompany from '@/components/ManageCompany.vue';
import ItemList from '@/components/ItemList.vue'
import AuthorsList from '@/components/AuthorsList.vue'
import UsersList from '@/components/UsersList.vue'
import CompaniesList from '@/components/CompaniesList.vue'
import TripPlacesList from '@/components/TripPlacesList.vue'
import UserPlacesList from '@/components/UserPlacesList.vue'
import UserTripsList from '@/components/UserTripsList.vue'
import UserOutingsList from '@/components/UserOutingsList.vue'
import UserItemsList from '@/components/UserItemsList.vue'
import UserCmntsList from '@/components/UserCmntsList.vue'
import CompanyOutingsList from '@/components/CompanyOutingsList.vue'
import Doc from '@/components/Doc.vue'
import ShowErr from '@/components/ShowErr.vue'
import Map from '@/components/Map'
//import AreaMap from '@/components/AreaMap'
import Login from '@/components/Login'
import CreateUser from '@/components/CreateUser'
import CreateSlUser from '@/components/CreateSlUser'
import Search from '@/components/Search'
import TravelGeo from '@/components/TravelGeo'
import OffersGeo from '@/components/OffersGeo'
import CompaniesGeo from '@/components/CompaniesGeo'
import GeoRefs from '@/components/GeoRefs'
import ManageRef from '@/components/ManageRef'
import ManageMeta from '@/components/ManageMeta'
import Compare from '@/components/Compare'
//import Foo from '@/components/Foo'
//import Test from '@/components/Test'
import NotFound from '@/components/NotFound'

export default [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/HomeLgd',
      component: HomeLgd
    },
    {
      path: '/ItemList',
      component: ItemList
    },
    {
      path: '/AuthorsList',
      component: AuthorsList
    },
    {
      path: '/UsersList',
      component: UsersList
    },
    {
      path: '/TripPlacesList/:tripName/:userName',
      component: TripPlacesList
    },
    {
      path: '/UserPlacesList/:userName',
      component: UserPlacesList
    },
    {
      path: '/UserTripsList/:userName',
      component: UserTripsList
    },
    {
      path: '/UserOutingsList/:userName',
      component: UserOutingsList
    },
    {
      path: '/CompaniesList',
      component: CompaniesList
    },
    {
      path: '/UserItemsList',
      component: UserItemsList
    },
    {
      path: '/UserCmntsList/:userName',
      component: UserCmntsList
    },
    {
      path: '/User',
      component: User
    },
    {
      path: '/Place/:itemName/:userName',
      component: Place
    },
    {
      path: '/Tour/:itemName/:userName',
      component: Tour
    },
    {
      path: '/Outing/:itemName/:userName',
      component: Outing
    },
    {
      path: '/Offer/:companyName/:itemName',
      component: Offer
    },
    {
      path: '/Company/:itemName',
      component: Company
    },
    {
      path: '/CompanyOutingsList/:companyName',
      component: CompanyOutingsList
    },
    {
      path: '/Requests',
      component: Requests
    },
    {
      path: '/ManagePlace/:placeName',
      //name: 'ManagePlace',
      component: ManagePlace,
      //props: false
    },
    {
      path: '/ManageTrip/:tripName',
      component: ManageTrip
    },
    {
      path: '/ManageOuting/:outingName',
      component: ManageOuting
    },
    {
      path: '/ManageCmnt',
      component: ManageCmnt
    },
    {
      path: '/ManageUser',
      component: ManageUser
    },
    {
      path: '/ManageGeo',
      component: ManageGeo
    },
    {
      path: '/ManageCompany/:companyName',
      component: ManageCompany
    },
    {
      path: '/Doc/:title',
      component: Doc
    },
    {
      path: '/ShowErr',
      component: ShowErr
    },

    {
      path: '/Map/:action/:itemName/:userName',
      component: Map,
    },

    {
      path: '/Map/:areamap/:country/:district/:city',
      //name: 'AreaMap',
      component: Map
    },
    {
      path: '/Compare/:userNameL/:outingNameL/:userNameR/:outingNameR',
      component: Compare
    },
/*
    {
      path: '/AreaMap/:country/:district/:city',
      component: AreaMap,
    },
*/
    {
      path: '/Login',
      component: Login
    },
    {
      path: '/CreateUser',
      //name: 'CreateUser',
      component: CreateUser,
      //props: true
    },
    {
      path: '/CreateSlUser',
      //name: 'CreateSlUser',
      component: CreateSlUser,
      //props: true
    },
    {
      path: '/Search',
      component: Search
    },
    {
      path: '/TravelGeo',
      component: TravelGeo
    },
    {
      path: '/OffersGeo',
      component: OffersGeo
    },
    {
      path: '/CompaniesGeo',
      component: CompaniesGeo
    },
    {
      path: '/GeoRefs',
      component: GeoRefs
    },
    {
      path: '/ManageRef',
      component: ManageRef
    },
    {
      path: '/ManageMeta',
      component: ManageMeta
    },
/*
    {
      path: '/Foo',
      name: 'Foo',
      component: Foo
    },
    {
      path: '/Test',
      name: 'Test',
      component: Test,
      props: true
    },
*/

    {
      path: '/:pathMatch(.*)*',
      component: NotFound
    }
/*
    {
      path: '/:catchAll(.*)',
      name: 'NotFound',
      component: NotFound
    }
*/

]
